import React, { useEffect, useState } from "react";
// Chakra imports
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Link,
  Switch,
  Text,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import {Link as RouterLink, useNavigate} from "react-router-dom"
import axios from "axios";
import { setLocalDate } from "../../../utils/accessLocalStorage";
// Assets
// import signInImage from "assets/img/signInImage.png";
let initialData={
  email:"",
  password:""
}

function SignIn() {
  // Chakra color mode
//https://636bda08ad62451f9fbd8076.mockapi.io/apnidukaan
const [state, setState] = useState(initialData);
const [auth, setAuth] = useState([]);
const navigate=useNavigate();
const Toast = useToast();
// console.log(state)

const getData=()=>{
  axios.get(`https://636bda08ad62451f9fbd8076.mockapi.io/apnidukaan`).then((res)=>{
    console.log(res)
    setAuth(res.data.items)
  });
}

const handleChange=(e)=>{
  setState({...state,[e.target.name ]:e.target.value})
}

const handleSubmit=(e)=>{

 let l1="";
 let l2="";
 let authData=auth.length>0 && auth.filter(({email,password})=>{
    return email===state.email && password===state.password 
    
 })
//  console.log(authData)
setState(initialData)
if(authData.length>0){
  setLocalDate("AdminEmail",authData[authData.length-1])
  navigate("/dashboard")
}else{
  Toast({
    title: `Authentication failed`,
    status: "warning",
    duration: 1500,
    position: "top",
    isClosable: true,
  });
}
}

useEffect(()=>{
  getData();
},[])

  const titleColor = useColorModeValue("teal.300", "teal.200");
  const textColor = useColorModeValue("gray.400", "white");
  return (
    <Flex position='relative' mb='40px'>
      <Flex
        h={{ sm: "initial", md: "75vh", lg: "85vh" }}
        w='100%'
        maxW='1044px'
        mx='auto'
        justifyContent='space-between'
        mb='30px'
        pt={{ sm: "100px", md: "0px" }}>
        <Flex
          alignItems='center'
          justifyContent='start'
          style={{ userSelect: "none" }}
          w={{ base: "100%", md: "50%", lg: "42%" }}>
          <Flex
            direction='column'
            w='100%'
            background='transparent'
            p='48px'
            mt={{ md: "150px", lg: "80px" }}>
            <Heading color={titleColor} fontSize='32px' mb='10px'>
              Welcome Back
            </Heading>
            <Text
              mb='36px'
              ms='4px'
              color={textColor}
              fontWeight='bold'
              fontSize='14px'>
              Enter your email and password to sign in
            </Text>
            <FormControl>
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                Email
              </FormLabel>
              <Input
              name="email"
              value={state.email}
              onChange={handleChange}
                borderRadius='15px'
                mb='24px'
                fontSize='sm'
                type='text'
                placeholder='Your email adress'
                size='lg'
              />
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                Password
              </FormLabel>
              <Input
              name="password"
              value={state.password}
              onChange={handleChange}
                borderRadius='15px'
                mb='36px'
                fontSize='sm'
                type='password'
                placeholder='Your password'
                size='lg'
              />
              <FormControl display='flex' alignItems='center'>
                <Switch id='remember-login' colorScheme='teal' me='10px' />
                <FormLabel
                  htmlFor='remember-login'
                  mb='0'
                  ms='1'
                  fontWeight='normal'>
                  Remember me
                </FormLabel>
              </FormControl>
              <Button
              onClick={handleSubmit}
                fontSize='10px'
                type='submit'
                bg='teal.300'
                w='100%'
                h='45'
                mb='20px'
                color='white'
                mt='20px'
                _hover={{
                  bg: "teal.200",
                }}
                _active={{
                  bg: "teal.400",
                }}>
                {/* <RouterLink to="/dashboard"> SIGN IN </RouterLink> */}
                SIGN IN
              </Button>
            </FormControl>
          </Flex>
        </Flex>
        <Box
          display={{ base: "none", md: "block" }}
          overflowX='hidden'
          h='100%'
          w='40vw'
          position='absolute'
          right='0px'>
          <Box
            bgImage={"https://t4.ftcdn.net/jpg/04/60/71/01/360_F_460710131_YkD6NsivdyYsHupNvO3Y8MPEwxTAhORh.jpg"}
            w='100%'
            h='100%'
            bgSize='cover'
            bgPosition='50%'
            position='absolute'
            borderBottomLeftRadius='20px'></Box>
        </Box>
      </Flex>
    </Flex>
  );
}

export default SignIn;
